<div class="row__charging">
  <div class="col__charging" *ngFor="let item of itemsCharging">
    <div class="item-charging">
      <div class="charging image"></div>
      <div class="charging__top">
        <div class="charging winery"></div>
        <div class="charging name"></div>

        <div class="charging addon"></div>
        <div class="charging price"></div>

        <div class="charging button"></div>
      </div>
    </div>
  </div>
</div>
